import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "./app";
import api from "./api";
import API_URL from "../config/ApiUrl";

const PortedOutFromUsReportsSlice = createSlice({
  name: "PortedOutFromUsReportsSlice",
  initialState: {},
  reducers: {},
});

export const addNewPortedOutFromUsReport =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const { year, month } = payload || {};

      // Ensure `request_id` is included in the payload
      const requestBody: any = {
        year,
        month,
      };

      // Make the API request with the constructed body
      const res = await api.post(
        API_URL.PORTED_OUT_FROM_US_REPORT.ADD,
        requestBody
      );
      return Promise.resolve(res.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchListPortedOutFromUsReports =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      // Destructure payload with default values
      const {
        year,
        month,
        date = "",
        current = 1,
        page_size = 10,
      } = payload || {};

      // Construct the query string dynamically
      const actionParts = [
        `report_date=${date}`,
        `current=${current}`,
        `page_size=${page_size}`,
      ];

      if (year) {
        actionParts.push(...actionParts, `year=${year}`);
      }

      if (month) {
        actionParts.push(...actionParts, `month=${month}`);
      }

      const uniqueArr = [...new Set(actionParts)];

      // Join query parts
      const action = `?${uniqueArr.join("&")}`;

      // Make the API call
      const response = await api.get(
        API_URL.PORTED_OUT_FROM_US_REPORT.LIST + action
      );

      // Return the response data
      return Promise.resolve(response?.data?.data);
    } catch (error: any) {
      // Improved error handling
      return Promise.reject(error?.response?.data || error.message);
    }
  };

export const deletePortedOutFromUsReport =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(
        API_URL.PORTED_OUT_FROM_US_REPORT.DELETE,
        payload
      );
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export default PortedOutFromUsReportsSlice.reducer;
